/**
 * Labstep
 *
 * @module screens/ResourceItem/Index/Breadcrumb
 * @desc ResourceItem Index Breadcrumb
 */

import EntityTemplateBreadcrumb from 'labstep-web/components/Entity/Template/Breadcrumb/Index';
import EntityImportActionPending from 'labstep-web/components/EntityImport/Action/Pending';
import { ResourceItemActionExportMenu } from 'labstep-web/components/ResourceItem/Action/Export/Menu';
import { ResourceTemplatePreview } from 'labstep-web/components/ResourceTemplate/Preview';
import { ICONS } from 'labstep-web/constants/icons';
import { Flex } from 'labstep-web/core/Flex';
import { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';

export const ResourceItemIndexBreadcrumb: React.FC = () => (
  <>
    <Flex grow>
      <EntityTemplateBreadcrumb
        entityName={Resource.entityName}
        entityPreview={({ entity, ...rest }): React.ReactElement => (
          <ResourceTemplatePreview
            resource={entity as Resource}
            {...rest}
          />
        )}
        showUncategorised={false}
        text={`All ${getHumanReadableEntityName(
          ResourceItem.entityName,
          true,
          true,
        )}`}
        indexRoute="group_resource_items"
        icon={ICONS[ResourceItem.entityName].primary}
      />
    </Flex>
    <EntityImportActionPending
      targetEntityName={ResourceItem.entityName}
    />
    <ResourceItemActionExportMenu />
  </>
);
